import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";

const List: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16">
            <g fill="none" fill-rule="evenodd">
                <g fill={`${getColor("text.main")}`} fill-rule="nonzero">
                    <path d="M0 .063L3.167.063 3.167 3.23 0 3.23zM0 6.397L3.167 6.397 3.167 9.564 0 9.564zM0 12.73L3.167 12.73 3.167 15.897 0 15.897zM12.667 6.397L6.333 6.397 6.333 9.563 19 9.563 19 6.397zM12.667 12.73L6.333 12.73 6.333 15.897 19 15.897 19 12.73zM15.833.063L6.333.063 6.333 3.23 19 3.23 19 .063z" />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(List);
